import * as React from 'react';

const ClosedCasesTable = ({ children }) => (
  <table className="closed-cases-bulk__table">
    <thead>
      <tr>
        <th><span>Case ID</span></th>
        <th className="closed-cases-bulk__child-header"><span>Children</span></th>
        <th><span>Date</span></th>
        <th><span>Close Reason</span></th>
      </tr>
    </thead>
    <tbody>
      {children}
    </tbody>
  </table>
);

export default React.memo(ClosedCasesTable)



// WEBPACK FOOTER //
// ./src/modules/ClosedCasesBulk/components/ClosedCasesTable.tsx